import { Colors } from 'cio-design-library/design-tokens'
import styled from 'styled-components'
import Media from 'builder/styles/media'

export const DividerContainer = styled.div`
  display: flex;
  gap: 16px;
  margin: 24px 0px 28px;
`

export const Line = styled.div`
  flex: 1;
  height: 1px;
  background: #e1e5e9;
  margin-top: auto;
  margin-bottom: auto;
`

export const OrText = styled.div`
  text-transform: capitalize;
  font-weight: 400;
  font-size: 16px;
  leading-trim: none;
  line-height: 20px;
  letter-spacing: 0%;
  color: ${Colors.Neutral50};
`

export const Wrapper = styled.div`
  padding: 42px 0 30px;

  ${Media.Phone`
    padding: 32px 0 26px;
  `};
`

export const Footer = styled.div`
  margin-top: 24px;
  font-size: 16px;
  line-height: 20px;
  color: ${Colors.Neutral60};
  text-align: center;

  & a {
    color: ${Colors.Blue50};
  }

  & a:hover {
    color: ${Colors.Blue60};
  }
`
